import getAttendeesNames from './getAttendeesNames';
import { getRecipientNames } from './getRecipientName';
import { isItemClassMeetingMessage } from '../smimeItemClassUtils';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import Item from 'owa-service/lib/contract/Item';
import Message from 'owa-service/lib/contract/Message';

/**
 * Gets TO or CC recipients displayed to user
 */
const getToAndCcRecipients = (item: Item): { toRecipients: string[]; ccRecipients: string[] } => {
    if (isItemClassMeetingMessage(item.ItemClass)) {
        const calendarItem = <CalendarItem>item;
        return {
            toRecipients: getAttendeesNames(calendarItem, true /** getRequiredAttendees */),
            ccRecipients: getAttendeesNames(calendarItem, false /** getRequiredAttendees */),
        };
    }
    const emailMessage = <Message>item;
    return {
        toRecipients: getRecipientNames(emailMessage.ToRecipients),
        ccRecipients: getRecipientNames(emailMessage.CcRecipients),
    };
};

export default getToAndCcRecipients;
